export default [
  {
    id: 'bleed',
    name: 'Sangrar',
    desc: 'Todo início de turno o personagem perde 2 pontos de PV.',
    img: '/assets/img/game_resources/efeitos/sangrar.jpg'
  },

  {
    id: 'freeze',
    name: 'Congelar',
    desc:
      'O personagem não pode fazer nenhuma ação e tem os atributos reduzidos em 2 pontos.',
    img: '/assets/img/game_resources/efeitos/congelar.jpg'
  },

  {
    id: 'burn',
    name: 'Queimar',
    desc: 'Todo início de turno o personagem perde 1 ponto de PV.',
    img: '/assets/img/game_resources/efeitos/queimar.jpg'
  },

  {
    id: 'poison',
    name: 'Envenenar',
    desc: 'Todo início de turno o personagem perde 2 pontos de PV. Mov -1.',
    img: '/assets/img/game_resources/efeitos/envenenar.jpg'
  },

  {
    id: 'paralyze',
    name: 'Paralisar',
    desc:
      'O personagem não pode fazer nenhuma ação e tem os atributos reduzidos em 1 pontos.',
    img: '/assets/img/game_resources/efeitos/paralisar.jpg'
  },

  {
    id: 'faint',
    name: 'Desmaiar',
    desc:
      'O personagem não pode fazer nenhuma ação e tem os atributos reduzidos em 3 pontos.',
    img: '/assets/img/game_resources/efeitos/desmaiar.jpg'
  }
]
